import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "#modals" }, [
    (_ctx.isVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["absolute top-0 left-0 right-0 bottom-0 p-2 pb-10 flex", _ctx.positionClass])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass([
                    'z-50 p-6 transition-all duration-300 w-full h-auto',
                    _ctx.fadeOut ? 'fade-out' : 'fade-in',
                    _ctx.transitionClass,
                    _ctx.colorClass,
                    _ctx.roundedClass,
                    _ctx.widthClass
                ]),
            style: _normalizeStyle([{ maxWidth: _ctx.maxWidth }, {"box-shadow":"rgba(0, 0, 0, 0.2) 0px 3px 5px -1px, rgba(0, 0, 0, 0.14) 0px 6px 10px 0px, rgba(0, 0, 0, 0.12) 0px 1px 18px 0px"}])
          }, [
            _renderSlot(_ctx.$slots, "default", { closeSnackbar: _ctx.closeSnackbar }),
            (!_ctx.hideCloseButton)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "absolute top-2 right-2 text-gray-500 hover:text-gray-700 focus:outline-none",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeSnackbar && _ctx.closeSnackbar(...args)))
                }, "×"))
              : _createCommentVNode("", true)
          ], 6)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}